import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton } from "../../components"



export const View = () =>{
 const ReportDocument = ({type,name,created,graycontent}:
    {type:string,name:string,graycontent:string,created:string})=>{
    return(
       
            <div className="report-and-document-content">
                <div className="type-and-name">
                   <div className="type">{type}</div> 
                    <div className="name"> {name}</div>
                    <div className="name"> {created}</div>
                </div>
                <div className="gray-content">{graycontent}</div>
            </div>

       
    )

 }

    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Report and Documents"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
      <div className="report-document-header">
            <strong>Documents requests</strong>
        </div> 
        <ReportDocument
        type="Type"
        name="Name"
        created=""
        graycontent="This is where we alert you if we need any paperwork
            from you. All is good right now!"
        />
         <div className="report-document-header">
            <strong>Documents</strong>
        </div> 
         <ReportDocument
        type="Type"
        name="Name"
        created="Created"
        graycontent="No documents found"
        />
      </Card>
        </>
    )
}
